import Button from 'components/common/Button';
import { usePushBookingRequestAppointmentsToBookingkitMutation } from 'graphql/mutations/appointment/generated/PushBookingRequestAppointmentsToBookingkit';
import React from 'react';
import { ArrowRepeat } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { formatGraphqlErrors } from 'utils/helpers';

const PushBookingRequestButton: FC<{ bookingRequestId: string }> = ({ bookingRequestId }) => {
  const { t } = useTranslation();

  const [pushAppointmentToBookingkitMutation, { loading }] = usePushBookingRequestAppointmentsToBookingkitMutation({
    variables: { bookingRequestId },
    onCompleted: () => {
      toast.success(t('appointments.bookingkitCell.pushedSuccessfullyNotification'));
    },
    onError: (error) => {
      toast.error(formatGraphqlErrors(error).message);
    },
  });

  return (
    <Button
      size="sm"
      variant="link"
      loading={loading}
      disabled={loading}
      onClick={() => pushAppointmentToBookingkitMutation()}
    >
      <small>
        {t('appointments.bookingkitCell.manualPushButton')} <ArrowRepeat />
      </small>
    </Button>
  );
};

export default PushBookingRequestButton;
